'use client'

import dynamic from 'next/dynamic'

// `ssr: false` keeps @xyflow/react out of the landing page's critical
// path; the placeholder reserves the same box so the swap causes no CLS.
export default dynamic(() => import('./PipelineDiagram'), {
  ssr: false,
  loading: () => <div style={{ width: '100%', aspectRatio: '16 / 7' }} />,
})
